<script>
    import {onMount} from 'svelte';
    import {notifier} from '@beyonk/svelte-notifications';
    import {addFormModal} from '../../Forms/ModalFormManager.svelte';

    import JSON5 from 'json5';

    import { getJWT } from '../../Utilities/Session.svelte';

    import Assessment from '../../Models/assessmentModel';
    import Loader from '../../Components/Loader.svelte';
    import ConditionalFormatting from './ConditionalFormattingField.svelte';

    const assessments = Assessment.getAssessmentList();

    import { engine } from '../../lib/liquid_engine';

    export let assessment_type;
    export let assessment_type_model;

    const gradientIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImdyYWRpZW50Ij48c3RvcCBjbGFzcz0ic3RvcDEiIG9mZnNldD0iMCUiLz48c3RvcCBjbGFzcz0ic3RvcDIiIG9mZnNldD0iMTAwJSIvPjwvbGluZWFyR3JhZGllbnQ+PHN0eWxlIHR5cGU9InRleHQvY3NzIj48IVtDREFUQVsuc3RvcDEge3N0b3AtY29sb3I6IHdoaXRlfTsuc3RvcDIge3N0b3AtY29sb3I6IGJsYWNrfTtdXT48L3N0eWxlPjwvZGVmcz48cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIGZpbGw9InVybCgjZ3JhZGllbnQpIi8+PC9zdmc+";
    const imageIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb24tdGFibGVyLXBob3RvIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgZmlsbD0ibm9uZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz48bGluZSB4MT0iMTUiIHkxPSI4IiB4Mj0iMTUuMDEiIHkyPSI4IiAvPjxyZWN0IHg9IjQiIHk9IjQiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgcng9IjMiIC8+PHBhdGggZD0iTTQgMTVsNCAtNGEzIDUgMCAwIDEgMyAwbDUgNSIgLz48cGF0aCBkPSJNMTQgMTRsMSAtMWEzIDUgMCAwIDEgMyAwbDIgMiIgLz48L3N2Zz4K";
    const clearImageIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb24tdGFibGVyLXBob3RvLW9mZiIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIGZpbGw9Im5vbmUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PGxpbmUgeDE9IjMiIHkxPSIzIiB4Mj0iMjEiIHkyPSIyMSIvPjxsaW5lIHgxPSIxNSIgeTE9IjgiIHgyPSIxNS4wMSIgeTI9IjgiLz48cGF0aCBkPSJNMTkuMTIxIDE5LjEyMmEzIDMgMCAwIDEgLTIuMTIxIC44NzhoLTEwYTMgMyAwIDAgMSAtMyAtM3YtMTBjMCAtLjgzMyAuMzQgLTEuNTg3IC44ODggLTIuMTMxbTMuMTEyIC0uODY5aDlhMyAzIDAgMCAxIDMgM3Y5Ii8+PHBhdGggZD0iTTQgMTVsNCAtNGMuOTI4IC0uODkzIDIuMDcyIC0uODkzIDMgMGw1IDUiLz48cGF0aCBkPSJNMTYuMzIgMTIuMzRjLjU3NyAtLjA1OSAxLjE2MiAuMTYyIDEuNjggLjY2bDIgMiIvPjwvc3ZnPg==";
    const gridIcon = "data:image/svg+xml;base64,CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBjbGFzcz0iaWNvbiBpY29uLXRhYmxlciBpY29uLXRhYmxlci10YWJsZSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIGZpbGw9Im5vbmUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PHJlY3QgeD0iNCIgeT0iNCIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiByeD0iMiIgLz48bGluZSB4MT0iNCIgeTE9IjEwIiB4Mj0iMjAiIHkyPSIxMCIgLz48bGluZSB4MT0iMTAiIHkxPSI0IiB4Mj0iMTAiIHkyPSIyMCIgLz48L3N2Zz4KCgo=";
    const placeHolderIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAADvUlEQVR4nO2dPWsVQRSGnyL+AIukMRERYiliEREstEoqESRgZ6EBtbIyRRDBxhDSmMY/oBiDhWAXFaLRRog2CkaIVUDBYJTgRyFosTfgR7Izs3dn5pzhPHAgELLznnnI7l3uzg4YhmEYhmEYhmGUyyBwCpgC5hLWAvAaeAfcA/ZG7lM0Q8A8sAb8ElI/gasxm5bKBPknv65OxmtdFgepThO5J9ynjseZAjnsAtbJP9EmpcMc+SfYpHQYI//EmpQOe4AN8k+qSekwjn/TS6S5//gSkKk4KT7XjrvAQMJMrzwyFStlhfoGFzNk6kaIaim9uJsbyZCrWyFqpQzjbqwvQ642hKiUMoq7qRy0JUSdFK1Cnjp+r1aKViFXqL4KKE6KZiFQoBTtQqAwKSUIgYKklCIECpFSkhAoQIpUIa6PtT+opG1VHx1/+2+dSdSTF1KFzHjkarMupmnLjVQhpz1ytVnf0rTlRqqQfR652q7RJJ05kCoE4JIjV9s1laateiQLAXhAfBGbdS5RT7VIF9IL3CS+DDtlBXIaWMWEiBGyyQBwgurGMLRMiDBMiDBMiDBMiDBMiDBMiDBMiDBMiDBMiDBMiDBMiDBMiDBMiDBMiDBMiDBMiDBUCHGtoPqUL1rrqBDiWmP4MF+01lEhBOAa24c8ljFX26gRAjDJ3+HeU72wrCRUCYHq9DUMHAJ6MmeJgTohpWNChGFChKFeyGHgPHCh87N2VAvZasHMTNZE3aNWSN0bSWcz5uoWtUI+Ux9cqxSVQnxXLmmUolLIDvyEaJSiUgjAHcqUolZIP2GLY7RIUSsE4ADlSVEtBMqTol4IlCWlCCFQjpRihEAZUrIKmaTaKsh3AmPUi5gNNiCbkMceg6eqt7GabEAWIZc9Bk5d12M02oAsQu57DJy6nsdotAFZhIS+YDhFvYnRaCB9uHMOxxg49ZvYfOp2jEYDGcGdszfGwLtpvhlKjPoao8kGLFKfcyXm4EeBl44AKeo71YticjJAtRmNK+tcijD7qS5UbdUzj8Y26wPVzeR2nAVuEHfbpKWAvONeMyqIWfybW2V7GX3Ak4BjpagNqo3R1NCWDIBbAcdKVWNNJyYHbcrYGXCsVJXk2tEWbcoAOBJwvBS1TrXdrAralgGy/kMWqDZiVkHI1t2+MjaRcA2ZCJkMCbgelGsqA/J9yloD5oGhwLzZ8X1QromMP0lxHzJFtQpssIuc2fF5UK5bGUYgdQ/KmYwM9APL/C9jGZORjR5gGnjUqWnKXAhqGIZhGCL4DZ5WRqXfygn/AAAAAElFTkSuQmCC";
    const conditionalFormattingIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb24tdGFibGVyLWNvZGUtcGx1cyIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIGZpbGw9Im5vbmUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIj48L3BhdGg+PHBhdGggZD0iTTkgMTJoNiI+PC9wYXRoPjxwYXRoIGQ9Ik0xMiA5djYiPjwvcGF0aD48cGF0aCBkPSJNNiAxOWEyIDIgMCAwIDEgLTIgLTJ2LTRsLTEgLTFsMSAtMXYtNGEyIDIgMCAwIDEgMiAtMiI+PC9wYXRoPjxwYXRoIGQ9Ik0xOCAxOWEyIDIgMCAwIDAgMiAtMnYtNGwxIC0xbC0xIC0xdi00YTIgMiAwIDAgMCAtMiAtMiI+PC9wYXRoPjwvc3ZnPg==";
    const setRowsIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZT0iY3VycmVudENvbG9yIiBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSI+PC9wYXRoPjxwYXRoIGQ9Ik0yMCA2djRhMSAxIDAgMCAxIC0xIDFoLTE0YTEgMSAwIDAgMSAtMSAtMXYtNGExIDEgMCAwIDEgMSAtMWgxNGExIDEgMCAwIDEgMSAxeiI+PC9wYXRoPjxsaW5lIHgxPSIxMiIgeTE9IjE1IiB4Mj0iMTIiIHkyPSIxOSI+PC9saW5lPjxsaW5lIHgxPSIxNCIgeTE9IjE3IiB4Mj0iMTAiIHkyPSIxNyI+PC9saW5lPjwvc3ZnPg==";

    let container;
    let spreadsheet;
    let loading = false;

    function save() {
        excel.template = spreadsheet.getData();

        assessment_type_model.saveExcelTemplate(excel).then(() => {
            notifier.success("Template Saved");
        })
    }

    function handleRowLoop(worksheet, idx) {
        let new_rows = [];
        let startloop = worksheet.rows[idx].cells[0].text.replace("rowfor", "for");

        let found = false;
        for (idx++; idx < worksheet.rows.len; idx++) {
            let row = worksheet.rows[idx]
            if (row) {
                if (row?.cells[0]?.text && row?.cells[0]?.text.search(/{%\s*rowfor/) != -1) {
                        let [new_idx, tpl] = handleRowLoop(worksheet, idx)
                        new_rows.push(tpl);
                        idx = new_idx
                } else if (row?.cells[0]?.text && row?.cells[0]?.text.search(/{%\s*endrowfor\s*%}/) != -1) {
                    found = true;
                    break;
                } else {
                    new_rows.push(JSON.stringify(row))
                }
            }
        }

        const liquid_template = `[${startloop}\n${new_rows.join(',\n')},\n{% endfor %}]`

        return [idx, liquid_template]
    }

    function generate_preview() {
        const template = spreadsheet.getData();

        addFormModal({
            fields: [
                {
                    name: "assessment",
                    label: "Assessment",
                    type: "select",
                    choices: {
                        static: $assessments.map((a) => {
                            return {
                                label: `${a.name} - ${a.assessment_type}`,
                                value: a
                            }
                        })
                    }
                }
            ]
        }).then(async (result) => {
            loading = true;

            const assessment_data = await Assessment.getAssessmentDataStatic(result.assessment._id);

            let new_template = JSON.parse(JSON.stringify(template));
            let tpl = JSON.parse(JSON.stringify(template))
            for (let sheet_idx = 0; sheet_idx < tpl.length; sheet_idx++) {
                const tpl_worksheet = tpl[sheet_idx];
                let worksheet = new_template[sheet_idx];

                worksheet.rows = {};

                let write_idx = 0;
                for (let row_idx = 0; row_idx < tpl_worksheet.rows.len; row_idx++) {
                    let row = tpl_worksheet.rows[row_idx]
                    if (row) {
                        if (row?.cells[0]?.text && row?.cells[0]?.text.search(/{%\s*rowfor/) != -1) {
                            let [new_idx, new_row_template] = handleRowLoop(tpl_worksheet, row_idx);

                            row_idx = new_idx;

                            const template = await engine.parseAndRender(new_row_template, assessment_data);

                            const new_rows = JSON5.parse(template)
                            for (let row of new_rows) {
                                worksheet.rows[write_idx] = row;
                                write_idx++;
                            }

                            continue
                        } else {
                            // check for template images
                            for (let col of Object.values(row.cells)) {
                                if (col?.image?.template) {
                                    col.image.data = await engine.parseAndRender(col.image.template, assessment_data)

                                    if (col.image.data.startsWith('http')) {
                                        col.image.data = await getDataUrl(col.image.data, col.image.height, col.image.width);
                                    }

                                    delete col.image.template;
                                }
                            }
                        }

                        worksheet.rows[write_idx] = row;
                    }
                    write_idx++
                }
            }

            engine.parseAndRender(JSON.stringify(new_template), assessment_data).then((rendered) => {
                generate_excel_preview(rendered).finally(() => {
                    loading = false;
                });
            }).catch((err) => {
                notifier.danger(`Error Generating Preview: ${err.message}`);
                loading = false;
            })

        })
    }

    async function generate_excel_preview(rendered_result) {
        let jwt = await getJWT();

        let res = await fetch('/generate/preview/excel', {
            method: "POST",
            body: rendered_result,
            headers: {
                'Authorization': `Bearer ${jwt}`,
                "content-type": "application/json"
            }
        });

        if (res.status != 200) {
            notifier.danger(res.statusText);
        } else {
            let blob = await res.blob();
            let url = URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.href = url;
            link.target = "_new";
            link.download = "Report_Preview.xlsx";
            link.click();

            URL.revokeObjectURL(url);
        }
    }

    function addImage(data, sheet) {
        let formData = {};
        let imageData;
        const selection = sheet.selector;

        // get sheetIndex
        let sheetIndex = spreadsheet.datas.indexOf(sheet);

        const cell = spreadsheet.cell(selection.ri, selection.ci, sheetIndex)
        if (cell && cell.image) {
            formData = {
                height: cell.image.height,
                width: cell.image.width
            }

            imageData = cell.image.data;

            if (cell.image.template) {
                formData.url = cell.image.template;
            }

            if (cell.image.position) {
                formData.position = "Absolute";
                formData.x = cell.image.position.left;
                formData.y = cell.image.position.top;
            } else {
                formData.position = "Relative"
                formData.x = cell.image.offset.left;
                formData.y = cell.image.offset.top;
            }
        }


        addFormModal({
            data: formData,
            title: "Image Properties",
            fields: [
                {
                    name: "img",
                    type: "file",
                    label: "Image"
                },
                {
                    name: 'url',
                    type: 'text',
                    label: "Image URL"
                },
                {
                    name: "height",
                    type: "number",
                    label: "Height"
                },
                {
                    name: "width",
                    type: "number",
                    label: "Width"
                },
                {
                    name: "position",
                    type: "select",
                    label: "Position",
                    choices: {
                        static: [
                            "Relative",
                            "Absolute"
                        ]
                    }
                },
                {
                    name: "x",
                    type: "number",
                    dflt: 0,
                    label: "X"
                },
                {
                    name: "y",
                    type: "number",
                    dflt: 0,
                    label: "Y"
                }
            ]
        }).then((data) => {

            const file = data.img[0];

            function setImage(image_url) {
                let image = {
                    data: image_url,
                    height: data.height,
                    width: data.width,
                }

                if (data.position == "Relative") {
                    image.offset = {
                        top: data.y,
                        left: data.x
                    }
                } else {
                    image.position = {
                        top: data.y,
                        left: data.x
                    }
                }

                if (data.template) {
                    image.template = data.template;
                }

                spreadsheet.cellImage(selection.ri, selection.ci, image, sheetIndex).reRender();
            }



            if (file) {
                getDataUrl(file, data.height, data.width).then((url) => {
                    setImage(url)
                }).catch(e => {
                    notifier.danger(e.message);
                });
            } else if (data.url) {
                if (data.url.startsWith("{")) {
                    data.template = data.url;
                    setImage(placeHolderIcon);
                } else {
                    getDataUrl(data.url, data.height, data.width).then(
                        setImage(url)
                    ).catch(e => {
                        notifier.danger(e.message);
                    });
                }
                } else if (imageData) {
                setImage(imageData)
                } else {
                notifier.danger("Invalid URL")
            }
        }).catch(() => {});
    }

    function getDataUrl(obj, height, width) {
        return new Promise((resolve, reject) => {

            function blobToImage(blob) {
                const reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                }
                reader.readAsDataURL(blob);
            }

            if (typeof obj === "string") {
                if (obj.startsWith("data:image")) {
                    let img = new Image();

                    if (height) {
                        img.style.height = `${height}px`;
                    }

                    if (width) {
                        img.style.width = `${width}px`;
                    }

                    img.onload = () => {
                        // add the child to the page so that we properly calculate image size
                        // necessary for SVG
                        img.style.position = "absolute";
                        img.style.left = "-99999px";
                        document.body.appendChild(img);
                        console.log(img);

                        const canvas = document.createElement("canvas");
                        canvas.height = img.height;
                        canvas.width = img.width;

                        const ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0, img.width, img.height);

                        document.body.removeChild(img);
                        resolve(canvas.toDataURL("image/png"));
                    }
                    img.src = obj;
                } else if (obj.startsWith('http')) {
                    getJWT().then((jwt) => {
                        fetch('/generate/relay/', {
                            method: "POST",
                            headers: {
                                'Authorization': `Bearer ${jwt}`,
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                url: obj
                            })
                        }).then((response) => {
                            response.blob().then(blob => {
                                blobToImage(blob);
                            })
                        })
                    });
                }
            } else {
                try {
                    blobToImage(obj)
                } catch (e) {
                    reject(e);
                }
            }

        })
    }

    function handleConditionalFormatting(data, sheet) {
        const sheetIndex = spreadsheet.datas.indexOf(sheet);
        addFormModal({
            title: "Conditional Formatting",
            width: 800,
            data: {
                rules: data.conditionalFormatting
            },
            fields: [
                {
                    name: "rules",
                    type: "custom",
                    component: ConditionalFormatting
                }
            ]
        }).then(results => {
           spreadsheet.setConditionalFormatting(results.rules, sheetIndex);
        }).catch(() => null);
    }

    $: excel = $assessment_type.excel_template;
    $: spreadsheet && spreadsheet.loadData(excel.template);

    onMount(() => {
        spreadsheet = new Spreadsheet(container, {
            view: {
				height: () => container ? container.clientHeight: 0,
				width: () => container ? container.clientWidth : 0
			}, extendToolbar: {
                right:[
                    {
                        tip: "Image",
                        icon: imageIcon,
                        onClick:  addImage
                    },
                    {
                        tip: "Clear Image",
                        icon: clearImageIcon,
                        onClick: (data, sheet) => {
                            const selection = sheet.selector;
                            const sheetIndex = spreadsheet.datas.indexOf(sheet);

                            const cell = spreadsheet.cellImage(selection.ri, selection.ci, undefined, sheetIndex).reRender();
                        }
                    },
                    {
                        tip: "Gradient Fill",
                        icon: gradientIcon,
                        onClick: (data, sheet) => {
                            let selection = sheet.selector;
                            let formData = {};
                            const cellStyle = spreadsheet.cellStyle(selection.ri, selection.ci);

                            if (cellStyle && typeof(cellStyle.bgcolor) != "string") {
                                formData.start = cellStyle.bgcolor[0][1];
                                formData.end = cellStyle.bgcolor[1][1];
                            }
                            addFormModal({
                                title: "Gradient Fill",
                                data: formData,
                                fields: [
                                    {
                                        name: "start",
                                        label: "Start Color",
                                        type: "color"
                                    },
                                    {
                                        name: "end",
                                        label: "End Color",
                                        type: "color"
                                    }
                                ]
                            }).then((result) => {
                                sheet.setSelectedCellAttr('bgcolor', [
                                    [0, result.start],
                                    [1, result.end]
                                ]);
                                spreadsheet.reRender()
                            }).catch(() => {})
                        }
                    },
                    {
                        tip: "ConditionalFormatting",
                        icon: conditionalFormattingIcon,
                        onClick: handleConditionalFormatting
                    },
                    {
                        tip: "Toggle Spreadsheet Grid",
                        icon: gridIcon,
                        onClick: (data, sheet) => {
                            let sheetIndex = spreadsheet.datas.indexOf(sheet);

                            sheet.toggleGrid(sheetIndex);
                            spreadsheet.reRender();
                        }
                    },
                    {
                        tip: "Set Rows",
                        icon: setRowsIcon,
                        onClick: (data, sheet) => {
                            addFormModal({
                                title: "Add Rows",
                                data: {
                                    rows: sheet.rows.len
                                },
                                fields: [
                                    {
                                        name: "rows",
                                        label: "Rows",
                                        type: "number"
                                    }
                                ]
                            }).then((results) => {
                                sheet.rows.len = results.rows;
                                sheet.rows._.len = results.rows;
                                spreadsheet.reRender();
                            })
                        }
                    }
                ]
            }
        });
        window.spreadsheet = spreadsheet

        return () => {
            delete window.spreadsheet;
        }

        /*
        setTimeout(() => {
            spreadsheet.cellImage(8,0, {
                data:"data:image/png;base64,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",
                height: 48,
                width: 212,
                offset: {
                    top: 10,
                    left: 10
                }
            }).reRender()
        }, 2000);
        */
    })
</script>
<Loader {loading} message="Generating Preview"></Loader>
<div class="columns">
    <div class="column">
        <h1 class="title is-1">
            Edit Excel Template
            <button class="button is-success is-pulled-right" on:click={save}>Save Template</button>
            <button class="button is-info" on:click={generate_preview}>Preview File</button>
        </h1>

        <div bind:this={container}>

        </div>
    </div>
</div>

<style>
    .columns {
        height: 100%;
    }

    .column {
        display: flex;
        flex-direction: column;
        flex: 1 auto;
    }

    .column > div {
        flex-grow: 1;
    }
</style>